import { useState } from "react";
import { toast } from "sonner";
import { Loader2, CheckCircle2 } from "lucide-react";
import { Reveal } from "../components/Reveal";
import { subscribe } from "../lib/api";

export const Signup = () => {
  const [email, setEmail] = useState("");
  const [state, setState] = useState("idle");

  const submit = async (e) => {
    e.preventDefault();
    setState("loading");
    try {
      const res = await subscribe(email);
      setState("done");
      toast.success(res.data?.already ? "You're already on the list." : "You're in! Watch your inbox for ticket drops.");
      setEmail("");
    } catch {
      setState("idle");
      toast.error("Please enter a valid email address.");
    }
  };

  return (
    <section id="signup" data-testid="email-signup-section" className="mx-auto max-w-7xl px-5 py-20 lg:px-12">
      <Reveal>
        <div className="relative overflow-hidden rounded-[32px] bg-[#FF5A1E] p-8 sm:p-14 lg:p-20">
          <div className="absolute -right-24 -top-24 h-80 w-80 rounded-full bg-[#9D4EDD] opacity-80 blur-3xl" />
          <div className="relative grid gap-10 lg:grid-cols-2 lg:items-end">
            <div>
              <p className="font-mono text-xs uppercase tracking-[0.3em] text-black">First to know</p>
              <h2 className="mt-4 font-display text-5xl font-extrabold uppercase leading-[0.88] text-black sm:text-7xl">Don't miss the drop.</h2>
              <p className="mt-5 max-w-md font-medium text-black/80">Get lineup announcements, presale codes and ticket releases straight to your inbox.</p>
            </div>
            <form onSubmit={submit} className="flex flex-col gap-3 sm:flex-row" data-testid="signup-form">
              <label htmlFor="signup-email" className="sr-only">Email address</label>
              <input id="signup-email" data-testid="signup-email-input" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@email.com" className="h-14 flex-1 rounded-full border-2 border-black/80 bg-transparent px-6 text-base font-medium text-black placeholder:text-black/60 focus:outline-none focus:ring-4 focus:ring-black/20" />
              <button data-testid="signup-submit-btn" disabled={state === "loading"} className="inline-flex h-14 items-center justify-center gap-2 rounded-full bg-[#0B0C10] px-8 font-mono text-sm font-semibold uppercase tracking-widest text-white transition-transform hover:scale-[1.03] active:scale-95">
                {state === "loading" ? <Loader2 className="animate-spin" size={18} /> : state === "done" ? <CheckCircle2 size={18} /> : null}
                {state === "done" ? "Subscribed" : "Sign Up"}
              </button>
            </form>
          </div>
        </div>
      </Reveal>
    </section>
  );
};
